import { Avatar, Table } from "flowbite-react";
import { useTranslation } from "react-i18next";
import { IMerchant } from "../../../interfaces";
import { DEFAULT_AVATAR } from "../../../shared/constants";

const TeamMembersModal = ({ teamMembers }: { teamMembers: IMerchant[] }) => {
  const { t } = useTranslation();
  return (
    <div className="overflow-x-auto border border-gray-200 dark:border-gray-700 rounded-md">
      <Table>
        <Table.Head className="border-b h-[50px] border-gray-200 dark:border-gray-700">
          <Table.HeadCell>{t("merchant.name")}</Table.HeadCell>
          <Table.HeadCell>{t("merchant.email")}</Table.HeadCell>
          <Table.HeadCell>{t("merchant.statusLabel")}</Table.HeadCell>
        </Table.Head>
        <Table.Body className="divide-y">
          {teamMembers.map((member) => (
            <Table.Row
              key={member.id}
              className="bg-white dark:border-gray-700 dark:bg-gray-800"
            >
              <Table.Cell>
                <div className="flex items-center gap-3">
                  <Avatar
                    img={(member?.profile_picture as string) || DEFAULT_AVATAR}
                    rounded
                    size="xs"
                    alt={member.name || member.schema || member.email}
                  />
                  {member.name || member.schema}
                </div>
              </Table.Cell>
              <Table.Cell>{member.email}</Table.Cell>
              <Table.Cell>
                {(() => {
                  return (
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${
                        member.is_active
                          ? "bg-green-100 text-green-800"
                          : "bg-red-100 text-red-800"
                      }`}
                    >
                      {t(
                        `merchant.status.${
                          member.is_active ? "active" : "inactive"
                        }`
                      )}
                    </span>
                  );
                })()}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </div>
  );
};

export default TeamMembersModal;
